import React, { createContext, useContext, useState } from "react";

import { PartnerRefValues, UserPrefillData } from "../../../routes/signup/Form";

type SSUPrefillContextType = {
  partnerRef: PartnerRefValues | null;
  userPrefillData: UserPrefillData | undefined;
  setPartnerRef: (partnerRef: PartnerRefValues | null) => void;
  setUserPrefillData: (userPrefillData?: UserPrefillData) => void;
};

export const SSUPrefillContext = createContext<
  SSUPrefillContextType | undefined
>(undefined);

export const SSUPrefillProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [partnerRef, setPartnerRef] = useState<PartnerRefValues | null>(null);
  const [userPrefillData, setUserPrefillData] = useState<
    UserPrefillData | undefined
  >(undefined);

  return (
    <SSUPrefillContext.Provider
      value={{
        partnerRef,
        userPrefillData,
        setPartnerRef,
        setUserPrefillData,
      }}
    >
      {children}
    </SSUPrefillContext.Provider>
  );
};

export const useSSUPrefillContext = () => {
  const context = useContext(SSUPrefillContext);

  // Fail silently if context is not available
  if (!context) {
    return {
      partnerRef: undefined,
      userPrefillData: undefined,
      setPartnerRef: () => {
        return;
      },
      setUserPrefillData: () => {
        return;
      },
    };
  }

  return context;
};
